import React from "react";
import ReactDOM from "react-dom";
import App from "../common/App";

const preloadedState = (window.document.getElementById("app-props") as HTMLInputElement)?.value;
const staticContent = React.createElement(App, JSON.parse(preloadedState));
ReactDOM.hydrate(staticContent, document.getElementById("app"));
